import { connect } from 'react-redux';
import MainMenu from '../../components/MenuComponent/Menu';
import { logout } from '../../redux/actions/auth';

const mapStateToProps = (state, ownProps) => ownProps;

const mapDispatchToProps = dispatch => ({
  actions: [
    {title: 'Logout', onClick: () => logout()(dispatch)}
  ]
})

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);



// WEBPACK FOOTER //
// ./src/Layouts/MainLayout/MainMenuConnected.js